// extracted by mini-css-extract-plugin
export default {"key-word":"style_key-word__GHZur","key-word__lists":"style_key-word__lists__css0T","key-word__list":"style_key-word__list__TVIX-"};